import styled from 'common/styled-components';
import { Paper, Typography } from '@material-ui/core';

const headerHeight = '64px';

export const MainWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;
export const Header = styled.div`
    height: ${headerHeight};
    background-color: ${props => props.theme.header};
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 8px ${props => props.theme.secondary.main};
`;
export const Title = styled(Typography)`
    flex: 1;
    text-align: center;
`;
export const WrapperContent = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: calc(100% - ${headerHeight});
`;
export const ListContainer = styled(Paper)`
    flex: 1;
`;
export const PageContainer = styled.div`
    flex: 3;
    margin: 10px;
    overflow: hidden;
`;
export const ListItemContainer = styled.div<{selected?: boolean}>`
    &:hover {
        ${props => !props.selected ? `background: ${props.theme.white.main}` : ' '}
        cursor: pointer;
    }
    ${props => props.selected ? `background: ${props.theme.white.dark}` : ' '}
`;